import { createLogisticsWrite } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

export {
  LogisticsStaleError,
  isStaleRefusal,
  LOGISTICS_WRITE_TIMEOUT_MS,
  type ILogisticsRevisionHandle,
} from '@d-orca/shared/client/apis';
export const { sendLogisticsWrite, fetchLogisticsRevision } = createLogisticsWrite(authedFetch);
